import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';
import { OperationType } from 'src/app/shared/interfaces/operation-type.enum';

export const ACX_CUSTODY_WITHDRAWAL_INFO_MESSAGE =
  'Consulte a plataforma ACX para mais informações';

export function isAcxCustodyWithdrawalOperation(operation: CarbonOperation): boolean {
  return operation.rawTypeCode === OperationType.DELIVERY;
}
